const APP_CONSTANTS = {
    PERFIL: {
        ADMIN: 1,
        SALES: 2,
    }
}

export default APP_CONSTANTS;